module.exports = __webpack_public_path__ + "media/images/patterns/5-9541c8db54d57d03641fe825167b733b.png";